/**
 * Format time duration for display
 */
export const formatTimeRemaining = (seconds: number): string => {
  const minutes = seconds / 60;
  return minutes >= 1 ? `${Math.floor(minutes)}min` : `${seconds}s`;
};

/**
 * Create error message with timestamp
 */
export const createTimestampedError = (error: string): string => {
  return `${new Date().toISOString()}: ${error}`;
};

/**
 * Truncate array to keep only last N items
 */
export const keepLastNItems = <T>(array: T[], count: number): T[] => {
  return array.slice(-count);
};
